<script lang="ts">
	import ArrowLeft from './icons/arrowLeft.svelte';
	import ArrowRight from './icons/arrowRight.svelte';

	interface Props {
		hasNext: boolean;
		hasPrev: boolean;
		onprevious?: () => void;
		onnext?: () => void;
	}

	let { hasNext = false, hasPrev = true, onprevious, onnext }: Props = $props();
</script>

<div class="flex gap-x-3">
	<div class="h-14 w-14">
		<button
			onclick={() => onprevious?.()}
			class="flex aspect-square h-full w-full items-center justify-center rounded-full border-2 border-brown-2 disabled:opacity-25"
			disabled={!hasPrev}
		>
			<ArrowLeft class="h-6 w-6" />
		</button>
	</div>

	<div class="h-14 w-14">
		<button
			onclick={() => onnext?.()}
			class="flex aspect-square h-full w-full items-center justify-center rounded-full border-2 border-brown-2 disabled:opacity-25"
			disabled={!hasNext}
		>
			<ArrowRight class="h-6 w-6" />
		</button>
	</div>
</div>
